import script from "./PerformerProjectTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectTasks.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectTasks.vue?vue&type=style&index=0&id=4be0fa4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be0fa4a"]])

export default __exports__